var map = {
	"./Aggression.svg": [
		152,
		3
	],
	"./Altruism.svg": [
		153,
		4
	],
	"./Artifice.svg": [
		154,
		5
	],
	"./Balance.svg": [
		155,
		6
	],
	"./Black.svg": [
		87
	],
	"./Blue.svg": [
		86
	],
	"./Chaos.svg": [
		156,
		7
	],
	"./Colorless.svg": [
		157,
		8
	],
	"./Green.svg": [
		89
	],
	"./Growth.svg": [
		158,
		9
	],
	"./Jund.svg": [
		159,
		10
	],
	"./MetaGame/Ambition.svg": [
		160,
		11
	],
	"./MetaGame/Balance.svg": [
		161,
		12
	],
	"./MetaGame/Chaos.svg": [
		162,
		13
	],
	"./MetaGame/Justice.svg": [
		163,
		14
	],
	"./MetaGame/Wisdom.svg": [
		164,
		15
	],
	"./Red.svg": [
		88
	],
	"./The Abzan Houses.svg": [
		165,
		16
	],
	"./The Azorius Senate.svg": [
		166,
		17
	],
	"./The Bant Shard.svg": [
		167,
		18
	],
	"./The Boros Legion.svg": [
		168,
		19
	],
	"./The Cult of Rakdos.svg": [
		169,
		20
	],
	"./The Esper Shard.svg": [
		170,
		21
	],
	"./The Golgari Swarm.svg": [
		171,
		22
	],
	"./The Grixis Shard.svg": [
		172,
		23
	],
	"./The Gruul Clans.svg": [
		173,
		24
	],
	"./The House Dimir.svg": [
		174,
		25
	],
	"./The Izzet League.svg": [
		175,
		26
	],
	"./The Jeskai Way.svg": [
		176,
		27
	],
	"./The Jund Shard.svg": [
		177,
		28
	],
	"./The Mardu Horde.svg": [
		178,
		29
	],
	"./The Naya Shard.svg": [
		179,
		30
	],
	"./The Orzhov Syndicate.svg": [
		180,
		31
	],
	"./The Selesnya Conclave.svg": [
		181,
		32
	],
	"./The Simic Combine.svg": [
		182,
		33
	],
	"./The Sultai Brood.svg": [
		183,
		34
	],
	"./The Temur Frontier.svg": [
		184,
		35
	],
	"./WUBRG.svg": [
		185,
		36
	],
	"./White.svg": [
		85
	],
	"./duals/Black and Green.svg": [
		186,
		37
	],
	"./duals/Black and Red.svg": [
		187,
		38
	],
	"./duals/Blue and Black.svg": [
		188,
		39
	],
	"./duals/Blue and Red.svg": [
		189,
		40
	],
	"./duals/Green and Blue.svg": [
		190,
		41
	],
	"./duals/Green and White.svg": [
		191,
		42
	],
	"./duals/Red and Green.svg": [
		192,
		43
	],
	"./duals/Red and White.svg": [
		193,
		44
	],
	"./duals/White and Black.svg": [
		194,
		45
	],
	"./duals/White and Blue.svg": [
		195,
		46
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 101;
module.exports = webpackAsyncContext;